import React from "react";
import TravelAndVisaView from "./view";

const TravelAndVisaPage = () => {
  return <TravelAndVisaView />;
};

export default TravelAndVisaPage;